import React from "react";
import { AlertTriangle, Users } from "lucide-react";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const SplitBadge = ({ r }) => (r.split ? (
  <span className="inline-block rounded bg-violet-100 text-violet-800 px-1.5 py-0.5 text-[11px] font-semibold" data-testid={`fees-split-${r.id}`}>
    Cash {inr(r.split.cash)} + UPI {inr(r.split.upi)}
  </span>
) : null);

export const LinkedChildren = ({ r }) => {
  const l = r.linked;
  if (!l) return null;
  return (
    <div className="mt-2 rounded-lg border border-amber-200 bg-amber-50 p-2 text-xs space-y-1" data-testid={`fees-linked-${r.id}`}>
      <div className="font-semibold text-amber-900 flex items-center gap-1"><Users className="h-3.5 w-3.5" /> Same screenshot used for {l.children.length} children</div>
      {l.children.map((c) => (
        <div key={c.id} className="flex flex-wrap gap-x-3 text-slate-700">
          <span className="font-medium">{c.student_name} ({c.roll_number})</span>
          <span>{inr(c.amount)}: Cash {inr(c.cash)} + UPI {inr(c.upi)}</span>
          <span className="text-slate-500">by {c.teacher_name} · {c.status}</span>
        </div>
      ))}
      <div className="font-semibold text-slate-900">Combined total {inr(l.total)} · UPI total {inr(l.total_upi)}{l.screenshot_amount ? ` · Screenshot shows ${inr(l.screenshot_amount)}` : ""}</div>
      {l.upi_over && <div className="text-red-700 font-semibold flex items-center gap-1" data-testid={`fees-linked-over-${r.id}`}><AlertTriangle className="h-3.5 w-3.5" /> UPI shares add up to more than the screenshot amount, please check</div>}
    </div>
  );
};
